<template>
    <grid ref="grid"
          :columnDefs="columnDefs"
          :suppressScrollOnNewData="true"
          :row-data="items"
          :is-auto-height="false"
          
    ></grid>
</template>

<script>
import { mapGetters } from 'vuex';
import Grid from '../../generic/grid/grid.vue';
import API from "../../../api";
import BusyModal from '../../generic/busy-modal/busy-modal.vue';
import {
    WORDPRESS_SETTINGS_WEBSITE_CATEGORIES_ENDPOINT, WORDPRESS_SETTINGS_WEBSITE_CATEGORIES_BY_ID_ENDPOINT,
    WORDPRESS_SETTINGS_WEBSITE_PROPERTY_ENDPOINT,
    WORDPRESS_SETTINGS_WEBSITE_PROPERTY_BY_ID_ENDPOINT
} from "../../../endpoints";

export default {
    components: {
        Grid,
        BusyModal,
    },
    props: {
        websiteId: {
            type: Number,
            required: true,
        },
        websiteUrl: {
            type: String,
            required: true
        },
        isPropertiesTab: {
            type: Boolean,
            required: false
        },
        isCategoriesTab: {
            type: Boolean,
            required: false
        },
        onSwitchWebsite: {
            type: Boolean,
            default: false
        },
        subTabsDataIsLoaded: {
            type: Function,
        }
    },
    computed: {
        ...mapGetters('header', ['userAllowWordpress']),
        ...mapGetters(
            'wordpressSettings', [
                'currentWebsitesProperties',
                'currentWebsitesCategories',
            ]
        ),
        updatePermanentLinkUrl() {
            if (this.isPropertiesTab) {
                return WORDPRESS_SETTINGS_WEBSITE_PROPERTY_BY_ID_ENDPOINT(this.websiteId, this.editPermalinkItemId);
            }
            if (this.isCategoriesTab) {
                return WORDPRESS_SETTINGS_WEBSITE_CATEGORIES_BY_ID_ENDPOINT(this.websiteId, this.editPermalinkItemId);
            }

        },
        columnDefs() {
            return [
                {
                    field: 'index',
                    headerName: 'Order',
                    type: 'idColumn',
                    maxWidth: 100,
                    cellStyle: { textAlign: 'center' },
                    cellClass: 'site-order',
                    sort: 'asc',
                },
                {
                    field: 'category_title',
                    headerName: 'Category',
                    maxWidth: this.isPropertiesTab ? 250 : 500,
                },
                {
                    field: 'name',
                    headerName: 'Property',
                    hide: this.isCategoriesTab,
                },
                {
                    field: 'permalink',
                    headerName: 'Permalink',
                    type: 'editableColumn',
                    valueGetter: (params) => {
                        return this.isPropertiesTab ? params.data.permalink ||  this.stringToSlug(params.data.name) : params.data.permalink || this.stringToSlug(params.data.category_title);
                    },
                    valueSetter: ({ oldValue, newValue, node, data }) => {
                        if (!this.userAllowWordpress) {
                            return false;
                        }
                        this.updateItemById('permalink', { id: data.id, value: newValue })
                        data.permalink = newValue || 'Set value';
                        return true;
                    },
                    cellClass: (data) => {
                        return `lx-editable-cell text-primary ${!data.value ? 'no-value' : ''}`;
                    },
                    cellRenderer: ({ data, value }) => {
                        return value || '<span class="permalink__not-set">Set link</span>';
                    },
                },
                {
                    field: 'is_enabled',
                    headerName: 'Display on Wordpress',
                    type: 'switchColumn',
                    maxWidth: 300,
                    minWidth: 150,
                    headerClass: 'wordpress-enabled',
                    cellClass: 'wordpress-enabled',
                    cellRendererParams: {
                        onChange: ({ node }, value) => {
                            this.onToggleClick({ id: node.id, value })
                        }
                    },
                    hide: !this.userAllowWordpress
                },
            ];
        },
            
    },
    data() {
        return {
            items: [],
            editPermalinkItemId: null,
            busy: false,
        }
    },
    mounted() {
        this.fetchItems();
    },
    methods: {
        async fetchItems() {
            const loadedItems = this.isPropertiesTab ? (
                this.currentWebsitesProperties(this.websiteId)
            ) : (
                this.isCategoriesTab
                    ? this.currentWebsitesCategories(this.websiteId)
                    : []
            );

            if (!loadedItems) {
                this.busy = true;

                try {
                    const url = this.isPropertiesTab
                        ? WORDPRESS_SETTINGS_WEBSITE_PROPERTY_ENDPOINT(this.websiteId)
                        : WORDPRESS_SETTINGS_WEBSITE_CATEGORIES_ENDPOINT(this.websiteId);
                    const response = await API.get(url);
                    this.items = response.data.map((item, index) => {
                        return { ...item, index: index + 1 };
                    });
                    this.subTabsDataIsLoaded && this.subTabsDataIsLoaded();
                    this.$store.dispatch(this.isPropertiesTab
                        ? 'wordpressSettings/setLoadedProperties'
                        : 'wordpressSettings/setLoadedCategories', {
                        id: this.websiteId,
                        list: this.items
                    });
                } catch (err) {
                    this.errorToast({text: `Could not load ${this.isPropertiesTab ? 'properties' : 'categories'} data.` })
                }

                this.busy = false;
            } else {
                this.items = loadedItems;
                this.subTabsDataIsLoaded && this.subTabsDataIsLoaded();
            }
        },
        onHideHandler(event, { permalink, id }) {
            this.editPermalinkItemId = null;

            if (event.trigger === 'ok') {
                this.updateList(id, 'permalink', permalink);
            }
        },
        onToggleClick(data) {
            this.updateItemById('is_enabled', data)
        },
        updateList(id, name, value) {
            this.items = this.items.map((item, index) => {
                if (+item.id === +id) {
                    item[name] = value;
                }

                return item;
            });
        },
        async updateItemById(name, { id, value }) {
            this.busy = true;
            try {
                const url = this.isPropertiesTab
                    ? WORDPRESS_SETTINGS_WEBSITE_PROPERTY_BY_ID_ENDPOINT(this.websiteId, id)
                    : WORDPRESS_SETTINGS_WEBSITE_CATEGORIES_BY_ID_ENDPOINT(this.websiteId, id)
                await API.put(url, { [name]: value });
                this.updateList(id, name, value);
            } catch (err) {
                this.errorToast({text: `Could update ${this.isPropertiesTab ? 'properties' : 'categories'} data.`})
            }
            this.busy = false;
        },
        stringToSlug (str) {
            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            const from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
            const to   = "aaaaeeeeiiiioooouuuunc------";

            for (let i = 0, l = from.length ; i < l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            return str;
        },
        //setColumns() {
        //    let columns = [
        //    ]
        //
        //    if (this.isCategoriesTab) {
        //        columns = columns.filter(i => i.field !== 'name');
        //    }
        //
        //    this.columnDefs = columns;
        //}
    },
    watch: {
        isPropertiesTab: function () {
            if (this.isPropertiesTab) {
                this.fetchItems();
            }
        },
        isCategoriesTab: function() {
            if (this.isCategoriesTab) {
                this.fetchItems();
            }
        },
        onSwitchWebsite: function() {
            if (this.onSwitchWebsite) {
                this.fetchItems();
            }
        }
    }
}
</script>

<style lang="scss">
.lx-editable-cell .ag-cell-wrapper .ag-cell-value {
    .permalink__not-set {
        text-decoration: underline;
    }
}

.wordpress-enabled {
    display: flex;
    justify-content: center !important;

    .ag-header-cell-text {
        text-align: center;
        display: block;
        width: 100%;
    }
}

.no-value {
    .ag-cell-value {
        text-decoration: none !important;
        opacity: 0.5;
        color: #6c757d;
    }
}

.site-order {
   .ag-cell-wrapper {
        justify-content: center !important;
   }
}
</style>
